module.exports = __webpack_public_path__ + "img/tiki_web.39cacd10.png";